module.exports = __webpack_public_path__ + "static/img/pic-bg-1.d910736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-1.png
// module id = ZEzI
// module chunks = 0